export const environment = {
  production: true,
  apiUrl: 'https://rda.teleconsulting.it',
  appVersion: 'v1.63.2',
  enableDevModule: false,
  stripePublicKey:
    'pk_live_51QWakZJtkhm6k1YxnDmpDRQytqCTNdbC5lkPYepjw8dz2hW6I2xDt06JaLcb63McKl7868APv0m6huU83yvLd5HA0002szZ80E',
};
